import { debounce } from "lodash";
import { someTime } from "./utils/misc";

declare const jQuery: any;
const $ = jQuery;

let $alreadyInited: any;
let resizeCorrectionInited: boolean = false;

export function initCollapsibleSections(): void
{
	let $wraps = $(".collapsible-sections").not($alreadyInited);
	if ($wraps.length === 0)
	{
		return;
	}
	$alreadyInited = (($alreadyInited || $()).add($wraps));
	const close = ($sections): void => {
		$sections.removeClass("open opened").off("transitionend").one("transitionend", function () {
			$(this).trigger("closed");
		}).trigger("closing").each(function () {
			$(this).find(".collapsible-section-body").first().css({ height: "" });
		});
	};
	const open = ($sections, $wrap): void => {
		$sections.addClass("open").off("transitionend").each(function () {
			const $section = $(this);
			const $sectionBody = $section.find(".collapsible-section-body").first();
			const height: number|"auto" = getSectionHeight($sectionBody);
			$sectionBody.css({ height });
			$section.one("transitionend", () => {
				$section.
					addClass("opened").
					trigger("opened", { height: $wrap.outerHeight(true) });
			});
			$section.trigger("opening", { height: height + $wrap.outerHeight(true) });
		});
	};
	const toggleOpen = ($section, $sections, $wrap, closeOthersOnOpen: boolean ) => {
		if ($section.hasClass("open"))
		{
			close($section);
			return;
		}
		if (closeOthersOnOpen)
		{
			close($sections.not($section));
		}
		open($section, $wrap);
	};
	$wraps.each(function () {
		const $wrap = $(this);
		const $sections = $wrap.children().children(".collapsible-section");
		const closeOthersOnOpen: boolean = $wrap.hasClass("close-others-on-open");
		$sections.each(function () {
			const $section = $(this);
			$section.children().children(".collapsible-section-header").on("click", function (ev) {
				toggleOpen($section, $sections, $wrap, closeOthersOnOpen);
			});
			if ($section.hasClass("open"))
			{
				open($section, $wrap);
			}
		}).on("open", function () {
			const $section = $(this);
			if (!$section.hasClass("open"))
			{
				open($section, $wrap);
			}
		});
	}).on("close-all", function () {
		const $wrap = $(this);
		const $sections = $wrap.children().children(".collapsible-section");
		close($sections);
	});
	$wraps.find("img").on("load", function () {
		setTimeout(correctHeightsOfOpenCollapsibles, 50);
	});
	const correctHeightsThrottled = debounce(correctHeightsOfOpenCollapsibles, 200, { trailing: true, leading: true });
	$wraps.on("heightchange", correctHeightsThrottled);
	if (!resizeCorrectionInited)
	{
		resizeCorrectionInited = true;
		$(window).on("resize load", correctHeightsThrottled);
    }
    correctHeightsOfOpenCollapsibles();
}

function getSectionHeight($sectionBody): number|"auto"
{
	return $sectionBody.children()[0].scrollHeight || "auto";
}

function correctHeightsOfOpenCollapsibles(disableAnim = true): void {
    $(`.collapsible-section.open`).each(async function () {
		const $section = $(this);
		const $sectionBody = $section.find(".collapsible-section-body").first();
		if (disableAnim)
		{
			$sectionBody.css({ transition: "none" });
			await someTime(20);
		}
	
		const height: number|"auto" = getSectionHeight($sectionBody);
		$sectionBody.css({ height });

		if (disableAnim)
		{
			await someTime(20);
            $sectionBody.css({ transition: "" });
		}
	});
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].initCollapsibleSections = initCollapsibleSections;

